<template>
    <v-container fluid fill-height>
        <v-row align="center" justify="center">
            <v-col v-if="!isBtrace" md="auto">
                <img :src="require('../assets/crc-logo.jpg')" style="max-width:200px" class="pb-3" />
                <img :src="require('../assets/b-trace-logo.png')" style="max-width:240px; padding-right:20px; padding-left: 20px" />
                <img :src="require('../assets/logo.svg')" style="max-width:200px" />
            </v-col>
            <v-col md="6">
                <h1 v-if="!isBtrace" class="display-2 font-weight-bold mb-3">
                    Welcome to B-QUAL
                </h1>
                <h1 v-else class="display-2 font-weight-bold mb-3">
                    Welcome to BTrace
                </h1>
                <p class="subheading font-weight-regular">
                    Demonstrate that your enterprise is operating in accordance with the industry requirements and expectations of consumers, markets, regulatory authorities and the
                    wider community, in relation to the key issues of food safety and industry best practice.
                </p>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios'

    export default {
        data() {
            return {
                isBtrace: false
            }
        },
        async mounted() {
            var result = await axios.get('/api/MemberOwnerships/IsBtrace');
            this.isBtrace = result.data;
        }
    }
</script>
